module.exports = __webpack_public_path__ + "static/media/c7.adc29c08.jpg";